<template>
  <el-dialog
    custom-class="edit-price-dialog"
    :visible.sync="dialogVisible"
    :show-close="false"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    width="1300px"
    append-to-body
  >
    <div class="selected-header">
      <span class="selected-title">{{ dialogTitle }}</span>
      <span class="selected-count">{{ accountItem.length }}</span>
    </div>
    <div class="account-box">
      <div
        v-for="item in accountItem"
        :key="item.account_id"
        class="account-tag"
      >
        <span
          class="account-tag__text"
          :title="`${item.account_name}(${item.account_id})`"
        >{{ item.account_name }}({{ item.account_id }})</span>
        <i
          class="el-icon-close account-tag__close"
          @click="handleRemove(item)"
        />
      </div>
    </div>

    <el-form
      class="edit-form"
      label-position="right"
      label-width="120px"
    >
      <el-form-item label="修改类型：">
        <el-radio-group v-model="modifyType">
          <el-radio label="roi">roi</el-radio>
          <el-radio label="date">投放日期</el-radio>
          <el-radio label="time">时间</el-radio>
        </el-radio-group>
      </el-form-item>

      <template v-if="modifyType === 'roi'">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="区间：">
              <div class="range-row">
                <el-input
                  v-model="start_roi"
                  class="range-input"
                />
                <span class="range-text">&lt; ROI &lt;</span>
                <el-input
                  v-model="end_roi"
                  class="range-input"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出价：">
              <el-input
                v-model="bid"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="ROI:">
              <el-input
                v-model="roi"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <template v-else-if="modifyType === 'date'">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="开始日期：">
              <el-date-picker
                v-model="beginDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                class="full-picker"
                :picker-options="beginDatePickerOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期：">
              <el-date-picker
                v-model="endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                class="full-picker"
                :picker-options="endDatePickerOptions"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <div
        v-else
        class="time-select-wrap"
      >
        <el-form-item label="投放周期：">
          <el-select
            v-model="timeSeriesType"
            class="cycle-select"
          >
            <el-option
              :value="1"
              label="每天"
            />
            <el-option
              :value="2"
              label="每周"
            />
            <el-option
              :value="3"
              label="全部"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="timeSeriesType !== 3"
          label="投放时段："
          class="time-slot-item"
        >
          <daily-time-bar
            v-if="timeSeriesType === 1"
            :key="'daily-' + visible"
            @update-selected="onDailySelected"
          />
          <div v-else>
            <div class="time-legend">
              <span class="time-legend__item">
                <i class="time-legend__block is-selected" />已选
              </span>
              <span class="time-legend__item">
                <i class="time-legend__block" />未选
              </span>
              <span class="time-legend__tip">可拖动鼠标选择时间段</span>
            </div>
            <time-selection
              :key="'week-' + visible"
              @update-selected="onTimeSelected"
            />
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="commitEditPrice"
      >确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updAdBid, batchUpdateDate } from '@/api/customer.js'
import TimeSelection from '@/views/massiveAdvertisingAD/AdvertisingTemplate/components/timeSelection.vue'
import DailyTimeBar from '@/views/tencentAD/accountList/components/dailyTimeBar.vue'

export default {
  name: 'EditPriceDialog',
  components: {
    TimeSelection,
    DailyTimeBar
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    accountItem: {
      type: Array,
      default: () => []
    },
    accountIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      modifyType: 'roi',
      start_roi: '0',
      end_roi: '0',
      roi: null,
      bid: null,
      beginDate: '',
      endDate: '',
      timeSeriesType: 1,
      dailySelected: [],
      timeSelected: [],
      loading: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      const titleMap = {
        roi: '确定修改当前roi吗?',
        date: '确定修改当前投放日期吗?',
        time: '确定修改当前时间吗?'
      }
      return titleMap[this.modifyType] || titleMap.roi
    },
    beginDatePickerOptions() {
      return {
        disabledDate(date) {
          return date.getTime() < new Date().setHours(0, 0, 0, 0)
        }
      }
    },
    endDatePickerOptions() {
      const begin = this.beginDate
      return {
        disabledDate(date) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          if (date.getTime() < today.getTime()) return true
          if (begin) {
            return date.getTime() < new Date(begin).setHours(0, 0, 0, 0)
          }
          return false
        }
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    handleRemove(item) {
      this.$emit('remove', item)
    },
    isEmpty(val) {
      return val === null || val === undefined || val === ''
    },
    resetForm() {
      this.modifyType = 'roi'
      this.start_roi = '0'
      this.end_roi = '0'
      this.bid = null
      this.roi = null
      this.beginDate = ''
      this.endDate = ''
      this.timeSeriesType = 1
      this.dailySelected = []
      this.timeSelected = []
    },
    onDailySelected(val) {
      this.dailySelected = val || []
    },
    onTimeSelected(val) {
      this.timeSelected = val || []
    },
    padTime(num) {
      return num < 10 ? '0' + num : String(num)
    },
    indexToTime(index) {
      const hour = Math.floor(index / 2)
      const minute = index % 2 === 0 ? '00' : '30'
      if (hour >= 24) return '24:00'
      return this.padTime(hour) + ':' + minute
    },
    rowToTimeSlots(row) {
      const slots = []
      if (!row || !row.length) return slots
      let start = null
      for (let i = 0; i <= row.length; i++) {
        const on = i < row.length && row[i]
        if (on && start === null) {
          start = i
        }
        if (start !== null && !on) {
          slots.push({
            start: this.indexToTime(start),
            end: this.indexToTime(i)
          })
          start = null
        }
      }
      return slots
    },
    buildTimeSeriesWeek() {
      const selected = this.timeSelected
      const week = []
      for (let day = 0; day < 7; day++) {
        week.push({
          time_slots: this.rowToTimeSlots(selected[day] || [])
        })
      }
      return week
    },
    hasTimeSelected() {
      if (this.timeSeriesType === 3) return true
      if (this.timeSeriesType === 1) {
        return this.dailySelected.some(item => item)
      }
      return this.timeSelected.some(row => row && row.some(item => item))
    },
    buildRoiPayload() {
      return {
        account_ids: this.accountIds,
        bid: Number(this.bid),
        start_roi: Number(this.start_roi),
        end_roi: Number(this.end_roi),
        roi: Number(this.roi)
      }
    },
    buildDateTimePayload() {
      const isDate = this.modifyType === 'date'
      const type = isDate ? 1 : this.timeSeriesType
      let allSlots = []
      let weekSlots = []
      if (!isDate && type === 1) {
        allSlots = this.rowToTimeSlots(this.dailySelected)
      } else if (!isDate && type === 2) {
        weekSlots = this.buildTimeSeriesWeek()
      } else if (!isDate && type === 3) {
        allSlots = [{ start: '00:00', end: '24:00' }]
      }
      return {
        account_ids: this.accountIds,
        date_or_time: isDate ? 1 : 2,
        begin_date: isDate ? this.beginDate : '',
        end_date: isDate ? this.endDate : '',
        time_series: {
          time_series_type: type,
          time_series_all: {
            time_slots: allSlots
          },
          time_series_week: weekSlots
        }
      }
    },
    validate() {
      if (this.modifyType === 'roi') {
        if (this.isEmpty(this.start_roi) || this.isEmpty(this.end_roi) || this.isEmpty(this.roi)) {
          this.$message.error('请正确填写信息')
          return false
        }
      } else if (this.modifyType === 'date') {
        if (this.isEmpty(this.beginDate) || this.isEmpty(this.endDate)) {
          this.$message.error('请选择投放日期')
          return false
        }
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        if (new Date(this.beginDate).getTime() < today.getTime() || new Date(this.endDate).getTime() < today.getTime()) {
          this.$message.error('开始日期和结束日期不能早于今天')
          return false
        }
      } else if (!this.hasTimeSelected()) {
        this.$message.error('请选择投放时间')
        return false
      }
      return true
    },
    commitEditPrice() {
      if (!this.validate()) return
      this.loading = true
      const requestFn = this.modifyType === 'roi' ? updAdBid : batchUpdateDate
      const payload = this.modifyType === 'roi' ? this.buildRoiPayload() : this.buildDateTimePayload()
      requestFn(payload)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.dialogVisible = false
            this.resetForm()
            this.$emit('success')
          } else {
            this.$message.error(res.message)
          }
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less">
.edit-price-dialog {
  border-radius: 8px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 24px 24px 8px;
  }

  .el-dialog__footer {
    padding: 8px 24px 24px;
  }

  .selected-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .selected-title {
    font-size: 14px;
    color: #303133;
    line-height: 22px;
  }

  .selected-count {
    font-size: 14px;
    color: #409eff;
    line-height: 22px;
  }

  .account-box {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
    max-height: 96px;
    overflow-y: auto;
    padding: 12px;
    background: #f5f5f5;
    border-radius: 4px;
  }

  .account-tag {
    display: flex;
    align-items: center;
    min-width: 0;
    height: 32px;
    padding: 0 10px;
    background: #ebebeb;
    border-radius: 4px;
  }

  .account-tag__text {
    flex: 1;
    overflow: hidden;
    color: #606266;
    font-size: 12px;
    line-height: 32px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .account-tag__close {
    margin-left: 8px;
    color: #909399;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: #606266;
    }
  }

  .edit-form {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;

    .el-form-item {
      margin-bottom: 18px;
    }

    .el-form-item__label {
      color: #606266;
      font-weight: 400;
    }

    .el-input__inner,
    .el-date-editor.el-input {
      background: #f5f5f5;
      border: none;
      border-radius: 4px;
    }

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }

    .el-date-editor .el-input__inner {
      background: #f5f5f5;
      border: none;
    }
  }

  .cycle-select {
    width: 200px;
  }

  .time-slot-item {
    .el-form-item__content {
      line-height: normal;
    }
  }

  .time-select-wrap {
    margin-top: 4px;
    margin-bottom: 8px;
    overflow-x: auto;

    > div:last-child {
      width: 100% !important;
    }

    .el-table {
      width: 100% !important;
    }
  }

  .time-legend {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #606266;
    font-size: 12px;
  }

  .time-legend__item {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }

  .time-legend__block {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 6px;
    background: #fff;
    border: 1px solid #e6ebf2;
    border-radius: 2px;

    &.is-selected {
      background: #3b82f6;
      border-color: #3b82f6;
    }
  }

  .time-legend__tip {
    color: #c0c4cc;
  }

  .range-row {
    display: flex;
    align-items: center;
  }

  .range-input {
    width: 80px;
  }

  .range-text {
    margin: 0 8px;
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
  }

  .full-picker {
    width: 100%;
  }

  .dialog-footer {
    text-align: right;
  }

  .el-button--default {
    background: #f5f5f5;
    border: none;
    color: #606266;
  }
}
</style>
